export default "/images/chevron-up.svg?0f9ac6feebc71692b1c5edb4cb434f54";